import { Box, Grid } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useOptimizerDefault from '@hook/optimizer/use-optimizer-default'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import Layout from '@component/Layout'
import LayoutEmpty from '@component/Layout/Empty'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBarDeafultOptmizer from '@component/Modules/Optimizer/Storange/DefaultConfig/SelectTableBar'

const OptimizerConfigDefaultView: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    headers,
    data,
    setFilters,

    pagination,
    filters,

    fetching,
    query,
    tableInteraction,
    actions,
    getData,
    getCenters,
    setFilename,
    handleUpdateParams
  } = useOptimizerDefault()

  const { hasSessions } = useSessions()
  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 225px)'
          : 'calc(100vh - 193px)'
        : hasSessions
        ? 'calc(100vh - 366px)'
        : 'calc(100vh - 334px)',
    [menuToggle, hasSessions]
  )

  useEffect(() => {
    getCenters()
    getData()

    // data?.length === 0 && getData()
    getFilters({
      companies: true,
      centers: true,
      productManagers: true
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout title="Otimizador - Config Default">
      <Grid templateColumns={'100vw'}>
        <Box>
          <LayoutTools
            title={'Configuracao Default'}
            filters={filters}
            actions={actions}
            query={query}
            // onSearchChange={setQuery}
            onTitleChange={setFilename}
            toggleFilters={setFilters.toggle}
            isDisabled={loading || fetching || data.length === 0}
          />
          <SelectedTableBarDeafultOptmizer />

          {loading ? (
            <LayoutLoader
              title="Recuperando informações..."
              message="Aguarde enquanto buscamos os dados no banco de dados"
            />
          ) : data.length === 0 ? (
            <LayoutEmpty
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          ) : (
            <Box>
              <Box paddingLeft={2}>
                <GridQuantity qtd={data.length.toString()} />
              </Box>

              <TableGrid
                id="config-default"
                headers={headers}
                query={query}
                data={data}
                itsSortable={true}
                loading={fetching}
                actions={tableInteraction}
                height={tableHeight}
                pagination={pagination}
                entity="config-default"
              />
            </Box>
          )}
        </Box>
      </Grid>
    </Layout>
  )
}

export default OptimizerConfigDefaultView
